<template>
    <div class='h100vh-100'>
        <SystemCounterBar ref="SystemCounterBar"></SystemCounterBar>
        <SystemCounterList ref="SystemCounterList" :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></SystemCounterList>
    </div>
</template>

<script>
    import SystemCounterBar from "./SystemCounterBar";
    import SystemCounterList from "./SystemCounterList";

    export default {
        name: "SystemCounter",
        props:[
            'gnbCounterTreeClickInfo'
        ],
        components:{
            SystemCounterBar,
            SystemCounterList
        },
        data() {
          return {
          }
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>
